export default __webpack_public_path__ + "static/media/949.ccf9fd6b.png";